import React from 'react';
import './App.css';
import { Button } from '@mui/material';
import { Link, useHistory } from 'react-router-dom';

const HomeScreen = ({ setIsSignedIn }) => {
  const history = useHistory();

  const handleImageClick = () => {
    history.push('/BlackJack');
  };

  return (
    <div className="home-container">
      <header className="header">
        <h1>Welcome to BlackJack Trainer</h1>
      </header>

      <section className="hero">
        <img
          src="https://i.ibb.co/cbCnR6c/chippy-removebg-preview.png"
          className="chippy chippy-left"
          alt="Chippy mascot left"
        />
        <img
          src="https://i.ibb.co/cbCnR6c/chippy-removebg-preview.png"
          className="chippy chippy-right"
          alt="Chippy mascot right"
        />
        <img
          src="https://i.ibb.co/NKK1n2m/207-2074612-premium-blackjack-redbubble-jack-of-spades-playing-card-removebg-preview.png"
          className="logo"
          alt="Blackjack Logo"
          onClick={handleImageClick}
        />
      </section>

      <section className="intro">
        <p>
          Welcome to an online web application that can be utilized to train and
          help memorize basic blackjack strategy.
        </p>
        <ul>
          <li>You will receive strategy recommendations based on the basic strategy chart below.</li>
          <li>You will significantly hone your blackjack skills, preparing you for the real table!</li>
        </ul>
        <Button
          className="play-button"
          variant="contained"
          color="error"
          size="large"
          component={Link}
          to="/BlackJack"
        >
          Play!
        </Button>
      </section>

      <footer className="footer">
        <p className="footer-text">
          The tables below represent the strategy our trainer Chippy will follow!
        </p>
        <img
          className="strategy-chart"
          src="https://www.blackjackapprenticeship.com/wp-content/uploads/2018/10/mini-blackjack-strategy-chart.png"
          alt="Blackjack Strategy Chart"
        />
      </footer>
    </div>
  );
};

export default HomeScreen;
